module.exports = __webpack_public_path__ + "img/violet_047.ce1ee047.png";